import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";
import React from "react";
import { StackedBarChart, Tooltip } from "bizcharts";
import { Box } from "@mui/system";
import DownloadButton from "../Common/DownloadButton";
import ModalTrigger from "../Common/ModalTrigger";

const HorizontalBarChart = (props) => {
  const [data, setData] = useState(undefined);

  const csv = props.csv;
  const { readString } = usePapaParse();

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        if (props.transform) {
          const transformedData = [];
          setData((prevState) => {
            results.data.forEach((d) => {
              transformedData.push({
                country: d["Countries"],
                region: "Unknown",
                value: d["Unknown"],
              });
              transformedData.push({
                country: d["Countries"],
                region: "Third Country",
                value: d["Third Country"],
              });
              transformedData.push({
                country: d["Countries"],
                region: "EU",
                value: d["EU"],
              });
              transformedData.push({
                country: d["Countries"],
                region: "Domestic",
                value: d["Domestic"],
              });
            });
            transformedData.reverse();
            return transformedData;
          });
        } else {
          setData(
            results.data.sort((a, b) =>
              a["Reporting country"] > b["Reporting country"] ? 1 : -1
            )
          );
        }
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };

  useEffect(() => {
    handleReadString();
  }, []);

  const colorMapping = {
  Unknown: "#787878",
  "Third Country": "#23649E",
  EU: "#90B1CE",
  Domestic: "#22294D",
  };
  
  const [canvas, setCanvas] = useState(undefined);
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <p
          className="titleChart"
          style={{
            fontFamily: "Roboto Condensed, sans-serif",
            marginBottom: ".5rem",
          }}
        >
          {props.title}
        </p>
        <Box display="flex" alignItems="center">
          <Box pl="10px" pt="4px">
            <DownloadButton
              canvas={canvas}
              fileName={props.title}
              csv={data}
              isRaw
            />
          </Box>
          <Box pl="10px">
            <ModalTrigger
              style={{ color: "#22294D", cursor: "pointer" }}
              text=""
            />
          </Box>
        </Box>
      </Box>
      {data && (
        <StackedBarChart
          onGetG2Instance={(chartInstance) => {
            setCanvas(chartInstance.chart.canvas);
          }}
          color={(region) => colorMapping[region.region || region["Pesticide region"]]}
          id="StackedBarChart"
          data={data}
          height={650}
          autoFit
          legend={{ position: "bottom", flipPage: false }}
          yField={props.yField}
          xField={props.xField}
          stackField={props.stackField}
          padding="auto"
          tooltip={{
            formatter: (d) => {
              return {
                name: d["Pesticide region"] ? d["Pesticide region"] : d.region,
                value:
                  (d["Region proportion per country"]
                    ? Math.round(d["Region proportion per country"] * 10) / 10
                    : d.value === "-"
                    ? "-"
                    : Math.round(d.value * 10) / 10) + "%",
              };
            },
            itemTpl:
              '<li data-index={index} class="g2-tooltip-list-item" style="margin-bottom:3px;">' +
              '<span style="background-color:{color};width:10px;border-radius:50%;height:10px;display:inline-block;margin-right:8px;"></span>' +
              "{name}: {value}" +
              "</li>",

            containerTpl:
              '<div class="g2-tooltip"  id="tooltipWrap" >' +
              '<div class="g2-tooltip-title" id="tooltipTitle" style="font-weight:bold;font-size:medium;color:#22294d;">  </div>' +
              '<ul class="g2-tooltip-list " style="color:#22294d;"></ul>' +
              "</div>",
          }}
          yAxis={{
            label: {
              style: {
                fontFamily: "Roboto Condensed, sans-serif",
              },
            },
          }}
          xAxis={{
            label: {
              style: {
                fontFamily: "Roboto Condensed, sans-serif",
              },
              formatter: (a, b, c) => {
                return a + "%";
              },
            },
            max: 100,
          }}
        ></StackedBarChart>
      )}
    </Box>
  );
};
export default HorizontalBarChart;
